export const SET_TAB_DATA = 'SET_TAB_DATA';
export const SET_TAB_LOADER = 'SET_TAB_LOADER';
export const SET_UPDATED_VALUES = 'SET_UPDATED_VALUES';
export const SET_SKILLS = 'SET_SKILLS';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_MICROSITES = 'SET_MICROSITES';
export const SET_MICROSITE_ACTIONS = 'SET_MICROSITE_ACTIONS';
export const SET_SPONSORS = 'SET_SPONSORS';
export const SET_FULL_PENDING_COUNT = 'SET_FULL_PENDING_COUNT';
export const SET_HUB_PENDING_COUNT = 'SET_HUB_PENDING_COUNT';
export const SET_FULL_DELETE_REVIEW_COUNT = 'SET_FULL_DELETE_REVIEW_COUNT';
export const SET_HUB_DELETE_REVIEW_COUNT = 'SET_HUB_DELETE_REVIEW_COUNT';
export const SET_ORG_IMG_URL='SET_ORG_IMG_URL';